import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { DashboardLayout } from '../../components/layout';
import StudentProgressDashboard from '../../components/student/StudentProgressDashboard';
import { facultyExamApi } from '../../api/examApi';
import { toast } from 'sonner';

export default function FacultyStudentLedgerPage() {
  const { studentId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    facultyExamApi.getStudentLedger(studentId)
      .then((res) => setData(res.data))
      .catch(() => toast.error('Failed to load student ledger'))
      .finally(() => setLoading(false));
  }, [studentId]);

  return (
    <DashboardLayout title="Student Ledger">
      <div className="max-w-4xl animate-fade-in space-y-6">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 text-slate-600 hover:text-primary dark:text-slate-400 dark:hover:text-accent-cool"
        >
          <ArrowLeft size={18} /> Back
        </button>

        <StudentProgressDashboard
          data={data}
          loading={loading}
          onDownloadSubmission={(submissionId) => facultyExamApi.downloadSubmission(submissionId)}
          onDownloadCorrected={(attemptId) => facultyExamApi.downloadCorrectedPaper(attemptId)}
          historyLabel="Exam History — your exams only"
          emptyHistoryMessage="This student has no attempts on your exams yet."
        />
      </div>
    </DashboardLayout>
  );
}
